import { Tag } from "antd";
import { OrderPaymentConst } from "states/order/order.models";

export interface IOrderPaymentMethodTagProps {
  method: string;
}

export function OrderPaymentMethodTag(props: IOrderPaymentMethodTagProps) {
  switch (props.method) {
    case OrderPaymentConst.method.card:
      return (
        <Tag style={{ marginRight: 0 }} color="purple">
          Thẻ visa / master / JCB
        </Tag>
      );
    case OrderPaymentConst.method.cash:
      return (
        <Tag style={{ marginRight: 0 }} color="green">
          Tiền mặt
        </Tag>
      );
    case OrderPaymentConst.method.cod:
      return (
        <Tag style={{ marginRight: 0 }} color="processing">
          Thanh toán khi nhận hàng
        </Tag>
      );

    default:
      return (
        <Tag style={{ marginRight: 0 }} color="cyan">
          Chuyển khoản
        </Tag>
      );
  }
}
